import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const PodiumTrophyIcon = (props: IconProps) => (
  <StyledIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1.61C5 2.496 5.019 3.331 5.041 3.467C5.143 4.099 5.372 4.558 5.82 5.034C6.387 5.635 6.963 5.914 7.796 5.989L8.133 6.02L8.223 6.287C8.42351 6.86289 8.75163 7.38599 9.18282 7.81718C9.61401 8.24837 10.1371 8.57649 10.713 8.777L10.98 8.867L10.991 9.434L11.002 10H9V12H15V10H12.998L13.009 9.434L13.02 8.867L13.287 8.777C13.8624 8.57552 14.3849 8.24707 14.816 7.81601C15.2471 7.38495 15.5755 6.86235 15.777 6.287L15.867 6.02L16.204 5.989C17.037 5.914 17.613 5.635 18.18 5.034C18.628 4.558 18.857 4.099 18.959 3.467C18.981 3.331 19 2.496 19 1.61V0H5V1.61ZM8 3.005V4.01L7.83 3.983C7.65559 3.95052 7.49263 3.87325 7.35711 3.75877C7.22159 3.64428 7.11817 3.49653 7.057 3.33C7.022 3.232 7.003 2.977 7.002 2.59L7 2H8V3.005ZM14 3.632C14 5.399 13.99 5.507 13.775 5.93C13.639 6.199 13.199 6.639 12.93 6.775C12.642 6.92188 12.3233 6.99846 12 6.99846C11.6767 6.99846 11.358 6.92188 11.07 6.775C10.801 6.639 10.361 6.199 10.225 5.93C10.01 5.507 10 5.399 10 3.632V2H14V3.632ZM16.998 2.59C16.997 2.977 16.978 3.232 16.943 3.33C16.8818 3.49653 16.7784 3.64428 16.6429 3.75877C16.5074 3.87325 16.3444 3.95052 16.17 3.983L16 4.01V2H17L16.998 2.59ZM7 15V17H0V24H24V18H17V13H7V15ZM15 18.5V22H9V15H15V18.5ZM7 20.5V22H2V19H7V20.5ZM22 21V22H17V20H22V21Z"
      fill="currentColor"
    />
  </StyledIcon>
)
